import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M18.134 5.002a1 1 0 0 1 .93.862c.005.03.008.064.013.133l.517 6.727c.125 1.631.188 2.447.711 2.97s1.339.586 2.97.711l6.728.518c.069.005.103.009.133.013a1 1 0 0 1 .862.93c.002.03.002.065.002.134 0 .07 0 .104-.002.134a1 1 0 0 1-.862.93c-.03.005-.064.008-.133.013l-6.727.517c-1.632.125-2.448.188-2.971.711s-.586 1.34-.711 2.97l-.517 6.728-.013.133a1 1 0 0 1-.93.862C18.104 31 18.069 31 18 31c-.07 0-.104 0-.134-.002a1 1 0 0 1-.93-.862l-.013-.133-.517-6.728c-.126-1.631-.189-2.447-.712-2.97s-1.339-.586-2.97-.711l-6.727-.517-.133-.013a1 1 0 0 1-.862-.93L5 18c0-.07 0-.104.002-.134a1 1 0 0 1 .862-.93c.03-.005.064-.008.133-.013l6.727-.517c1.631-.126 2.447-.189 2.97-.712s.586-1.339.711-2.97l.518-6.727c.005-.069.009-.103.013-.133a1 1 0 0 1 .93-.862C17.896 5 17.931 5 18 5c.07 0 .104 0 .134.002"
	})
});
export default SvgIcoPlus;
